module.exports = __webpack_public_path__ + "static/GreytHR-6c3ce81d91639007527d414a3a45c595.jpg";